
export default function CTA() {
  return (
    <section id="contact" className="py-32 px-6 lg:px-12 bg-gray-900">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
          Ready to close your diabetic eye exam gaps this year?
        </h2>
        
        <div className="flex flex-wrap justify-center gap-4 mt-12">
          <a
            href="/contact"
            className="bg-primary text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-primary-dark hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2 group"
          >
            <span>Request a Demo</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
